export default __webpack_public_path__ + "static/media/Brow_6_C5.5a39b080.svg";